/**
 * Pushes analytics data for the "Clear All" filters action.
 * @return {void}
 */
import { getPageType } from "@/utils/helper"

export const getAnalyticsDataForClearAll = () => {
  const pageEvent = window.pageObj || {}
  // KdsGetAnalyticsDataForClearAll
  const kohlerDatalayer = window.kohler.datalayer
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetAnalyticsDataForClearAll",
      params: {},
    },
  })
}

/**
 * Pushes analytics data for closing the filter overlay.
 * @return {void}
 */
export const getAnalyticsDataForFilterCloseOverlay = () => {
  const pageEvent = window.pageObj || {}
  // KdsGetAnalyticsDataForFilterCloseOverlay
  const kohlerDatalayer = window.kohler.datalayer
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetAnalyticsDataForFilterCloseOverlay",
      params: {},
    },
  })
}

/**
 * Pushes analytics data for the "View All Results" CTA.
 * @return {void}
 */
export const getAnalyticsDataForViewAllResultsCTA = () => {
  const pageEvent = window.pageObj || {}
  // KdsGetAnalyticsDataForViewAllResultsCTA
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  const kohlerDatalayer = window.kohler.datalayer
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetAnalyticsDataForViewAllResultsCTA",
      params: {},
    },
  })
}

/**
 * Pushes analytics data for social share actions.
 * @param {boolean} clickInternal
 * @param {string} name
 * @param {string} link
 * @param {string} share
 * @return {void}
 */
export const getAnalyticsDataForSocialShare = (
  clickInternal,
  name,
  link,
  share
) => {
  const eventInfo = {
    eventAction: "plp share",
    eventName: "plp share",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${name}`,
    internalLinkPosition: "plp",
    internalLinkType: "plp:share",
    internalLinkZoneName: "plp:promo tiles",
    internalLinkURL: link,
    clickInternalLinks: `${clickInternal}`,
  }
  if (share) {
    return {
      "data-datalayer-id": "kds-element-plp",
      "data-datalayer-data": JSON.stringify(eventInfo),
    }
  }
  const pageEvent = window.pageObj || {}
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  const kohlerDatalayer = window.kohler.datalayer
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetAnalyticsDataForSocialShare",
      params: {
        clickInternal,
        name,
        link,
      },
    },
  })
}

/**
 * Pushes analytics data for showing or hiding filter options.
 * @param {boolean} showHide
 * @return {void}
 */
export const getShowHideFilterOptionAnalyticsData = showHide => {
  const pageEvent = window.pageObj || {}
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  const kohlerDatalayer = window.kohler.datalayer
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetShowHideFilterOptionAnalyticsData",
      params: {
        showHide,
      },
    },
  })
}

/**
 * Pushes analytics data for sort by filter click.
 * @param {string} e
 * @return {void}
 */
export const getAnalyticsDataForSortByClick = e => {
  const pageEvent = window.pageObj || {}
  // KdsGetAnalyticsDataForSortByClick
  const kohlerDatalayer = window.kohler.datalayer
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetAnalyticsDataForSortByClick",
      params: { sortBy: e },
    },
  })
}

/**
 * Pushes analytics data for facet checkbox filter.
 * @param {string} actionType - The type of filter action (e.g., "add", "remove").
 * @param {string} value - The value of the facet checkbox.
 * @param {string} facet - The name of the facet.
 * @param {Array} filterArray - The array of currently applied filters.
 * @return {void}
 */
export const getFilterAnalyticsForFacetCheckbox = (
  actionType,
  value,
  facet = "",
  filterArray
) => {
  const pageEvent = window.pageObj || {}
  const formatFacet = facet.toLowerCase()
  const kohlerDatalayer = window.kohler.datalayer
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetFilterAnalyticsForFacetCheckbox",
      params: {
        actionType,
        value,
        facet: formatFacet,
        filterArray,
      },
    },
  })
}

/**
 * Pushes analytics data for print or share actions on the PLP.
 * @param {string} printOrShare - The action type, either "print" or "share".
 * @return {void}
 */
export const addPrintOrShareAnalytics = printOrShare => {
  const kohlerDatalayer = window.kohler.datalayer
  const pageEvent = window.pageObj || {}
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsPrintOrShare",
      params: {
        printOrShare,
      },
    },
  })
}

export const FILTER = {
  EXPAND: "expand",
  COLLAPSE: "collapse",
  FILTERS: "filters",
  HIDE_DISCONTINUED: "hide discontinued products",
}

/**
 * Pushes analytics data for expanding or collapsing a filter group on the PLP.
 * @param {boolean} collapseState - True if the filter group is expanded, false if collapsed.
 * @param {string} facetName - The name of the facet being expanded or collapsed.
 * @return {void}
 */
export const addCollapseAnalytics = (collapseState, facetName = "") => {
  const kohlerDatalayer = window.kohler.datalayer
  const formatFacetName =
    typeof facetName === "string" ? facetName.toLowerCase() : ""
  const pageType = getPageType()
  const pageEvent = window.pageObj || {}
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsAddCollapseAnalytics",
      params: {
        collapseState,
        facetName: formatFacetName,
      },
    },
  })
}

export const getTrackingAttributesForSort = label => {
  return JSON.stringify({
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${label.toLowerCase()}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    eventAction: "plp sort by filter",
    eventName: "plp sort by filter",
    internalLinkPosition: "plp",
    internalLinkType: "plp:sort by",
    internalLinkZoneName: "plp:sort by filter",
  })
}

export const getFilterAnalyticsForTagClearCTA = (filterArray, value, facet) => {
  const pageEvent = window.pageObj || {}
  const kohlerDatalayer = window.kohler.datalayer
  const pageType = getPageType()
  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
    page: updatedPageEvent,
    eventMetaData: {
      experience: "plpV3filter",
      eventType: "KdsGetFilterAnalyticsForTagClearCTA",
      params: {
        filterArray,
        value,
        facet,
      },
    },
  })
}

export const getTrackingAttributeForClearAllCTA = () => {
  return JSON.stringify({
    eventAction: "plp clear all filter",
    eventName: "plp clear all filter",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "clear all",
    internalLinkPosition: "plp",
    internalLinkType: "plp:clear all",
    internalLinkZoneName: "plp:filters",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}
